var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_search_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_search_white"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8047379,27.8619288 C29.0650874,28.1222783 29.0650874,28.5443883 28.8047379,28.8047379 C28.5443883,29.0650874 28.1222783,29.0650874 27.8619288,28.8047379 L20.6832177,21.6260267 C20.5515645,21.4943735 20.3279703,21.4843197 20.1876307,21.5989225 C20.1876307,21.5989225 20.0783999,21.6933553 19.8865085,21.8356272 C18.3347087,22.9861611 16.4134913,23.6666667 14.3333333,23.6666667 C9.17867566,23.6666667 5,19.487991 5,14.3333333 C5,9.17867566 9.17867566,5 14.3333333,5 C19.487991,5 23.6666667,9.17867566 23.6666667,14.3333333 C23.6666667,16.3660955 23.0168181,18.2470775 21.9135364,19.7798637 C21.7482025,20.0095617 21.5990381,20.1855125 21.5990381,20.1855125 C21.4822903,20.3287343 21.4924977,20.5496887 21.6260267,20.6832177 L28.8047379,27.8619288 Z M14.3333333,22.3333333 C18.7516113,22.3333333 22.3333333,18.7516113 22.3333333,14.3333333 C22.3333333,9.91505533 18.7516113,6.33333333 14.3333333,6.33333333 C9.91505533,6.33333333 6.33333333,9.91505533 6.33333333,14.3333333 C6.33333333,18.7516113 9.91505533,22.3333333 14.3333333,22.3333333 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchWhite);
export default __webpack_public_path__ + "static/media/ic_search_white.060b98bd3091d0320d1783de76cc37a5.svg";
export { ForwardRef as ReactComponent };